import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { bridgeBackgroundOptions } from "../../src/bridge_background_options"
import {
  bridgeMenuItems,
  clickBridgeMenuItem,
  observeBridgeMenuChanges,
  stopObservingBridgeMenuChanges
} from "../../src/bridge_menu_items"

// MenuComponent - Adds a native nav bar menu (⋯) whose entries mirror hidden
// item elements in the DOM.
//
// The container element carries the menu's own bridge attributes:
//   data-bridge-ios-image  SF Symbol for the menu button (e.g. "ellipsis")
//   data-bridge-side       "left" or "right" (default: "right")
//
// Item attributes are documented in src/bridge_menu_items.js.
//
// The native side replies to "connect" with `{ index }` when a non-share entry
// is tapped; we click the matching item element. Entries with action "share"
// are handled entirely natively (share sheet) and never reply.
//
// A morph refresh can change the items without reconnecting this controller,
// so any change inside the element re-sends "connect" and native replaces the
// menu in place.
export default class extends BridgeComponent {
  static component = "menu"
  static targets = ["item"]

  connect() {
    super.connect()
    observeBridgeMenuChanges(this, () => this.#sendConnect())
    this.#sendConnect()
  }

  disconnect() {
    stopObservingBridgeMenuChanges(this)
    super.disconnect()
  }

  #sendConnect() {
    const element = this.bridgeElement
    const image = element.bridgeAttribute("ios-image")
    const side = element.bridgeAttribute("side") || "right"
    const items = bridgeMenuItems(this.itemTargets)

    this.send("connect", { image, side, items, ...bridgeBackgroundOptions(this.element) }, (message) => {
      clickBridgeMenuItem(this.itemTargets, message)
    })
  }
}
